import { gql } from '@apollo/client';

import { AppSubscriptionFragment } from './appSubscriptions.fragment';

export * from './appSubscriptions.query.generated';

export const APP_SUBSCRIPTIONS = gql`
  ${AppSubscriptionFragment}
  query appSubscriptions(
    $appId: ID!
    $page: Int
    $perPage: Int
    $query: String
    $orderBy: AppSubscriptionsOrderByEnum
    $order: QueryOrderEnum
  ) {
    appSubscriptions(appId: $appId, page: $page, perPage: $perPage, query: $query, orderBy: $orderBy, order: $order) {
      nodesCount
      pagesCount
      nodes {
        ...AppSubscriptionFragment
      }
      hasNextPage
      hasPreviousPage
    }
  }
`;
